<app-title title=" {{ 'PAGINA_LISTAR_PESSOA.TITULO' | translate }}"></app-title>
<section>
  <form [formGroup]="filtroForm" class="n-form" (ngSubmit)="buscarPessoas()">
    <div
      class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
    >
      <p-floatLabel>
        <input
          pInputText
          id="username"
          formControlName="nome"
          required="true"
        />
        <label for="username" class="ng-invalide"> {{ 'PAGINA_LISTAR_PESSOA.NOME' | translate }}</label>
      </p-floatLabel>

      <p-floatLabel>
        <input
          pInputText
          id="email"
          formControlName="email"
          required="true"
          type="email"
        />
        <label for="email" class="ng-invalide">{{ 'PAGINA_LISTAR_PESSOA.EMAIL' | translate }}</label>
      </p-floatLabel>

      <p-floatLabel>
        <p-inputMask
          mask="(99) 99999-9999"
          formControlName="telefone"
          id="ssn_input"
        />
        <label for="telefone" class="ng-invalide">{{ 'PAGINA_LISTAR_PESSOA.TELEFONE' | translate }}</label>
      </p-floatLabel>
      <p-dropdown
        [options]="simNaoConst"
        formControlName="status"
        optionLabel="description"
        placeholder="Status da conta"
        optionValue="value"
        [showClear]="true"
      />
      <!-- <p-dropdown
        [options]="sistemasConst"
        formControlName="sistema"
        optionLabel="description"
        placeholder="Sistema"
        [showClear]="true"
      /> -->
      <p-button label="Pesquisar" type="submit" />
    </div>
  </form>
</section>
<section class="section-margin">
  <div class="n-container p-5 n-card2">
    <p-table [value]="pessoas" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>{{ 'PAGINA_LISTAR_PESSOA.TELEFONE' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_PESSOA.NOME' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_PESSOA.EMAIL' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_PESSOA.STATUS' | translate }}</th>
          <th>{{ 'PAGINA_LISTAR_PESSOA.ACOES' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-pessoa let-columns="columns">
        <tr>
          <td>{{pessoa.telefone}}</td>
          <td>{{pessoa.nome}}</td>
          <td>{{pessoa.email}}</td>
          <td>
            <p-tag
              [value]="pessoa.status === true ? ('PAGINA_LISTAR_PESSOA.ATIVO' | translate)  : ('PAGINA_LISTAR_PESSOA.INATIVO' | translate)"
              [severity]="pessoa.status === true ? 'success' : 'danger'"
            />
          </td>
          <td>
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-eye"
              (click)="selectPessoa(pessoa)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>

